<template>
  <section data-setting-panel :class="[style.panelComponent, panelClass]">
    <div v-if="$slots.header" :class="style.header">
      <slot name="header" />
      <ButtonIcon
        @click="handleClose"
        :icon="closeIcon"
        variant="ghost"
        size="28"
      />
    </div>

    <div :class="style.content">
      <slot />
    </div>

    <div v-if="$slots.footer" :class="style.footer">
      <slot name="footer" :close="handleClose" />
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./PanelComponent.module.scss";
import GhostButton from "@/elements/UI/button/ButtonStyle/Default/ghost/GhostButton.vue";
import closeIcon from "$images/icons/button/Name=Close, Size=16, Tone=Default.svg";
import ButtonIcon from "@/elements/UI/button/ButtonIcon/ButtonIcon.vue";

export default defineComponent({
  name: "PanelComponent",
  components: {ButtonIcon, GhostButton},
  emits: ["close"],
  props: {
    panelClass: {
      type: [String, Array, Object] as PropType<
        string | string[] | Record<string, boolean>
      >,
      default: ""
    }
  },
  data() {
    return {
      style,
      closeIcon
    };
  },
  methods: {
    handleClose(): void {
      this.$emit("close");
    }
  }
});
</script>
